import { render, staticRenderFns } from "./recipe-list.vue?vue&type=template&id=1f464439&"
import script from "./recipe-list.vue?vue&type=script&lang=js&"
export * from "./recipe-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports